export default {
  API_ENDPOINT:
    process.env.API_ENDPOINT || 'https://secret-river-60975-47a923846253.herokuapp.com/api',
  TOKEN_KEY: 'chore-runner-token',
  TYPE: 'type',
};
